import React, { useState } from 'react';
import { motion } from 'framer-motion';
//import { useLocation } from 'react-router-dom';
import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import {
  setFilters,
  clearRealEstatesFilter,
} from '../../slices/realEstateSlice';
import RealEstatesFilters from './filters/RealEstatesFilters';
import RealEstatesGrid from './RealEstatesGrid';
import RealEstatesHeroSection from './RealEstatesHeroSection';
import { scrollToRealEstatesContent } from '../../utilities/scrollToRealEstatesContent';

const EMPTY_FILTERS = {
  city: '',
  realEstateTypeId: '',
  priceRange: 0,
  businessType: '',
};

export default function RealEstatesSection({ realEstateTypes }) {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 9;
  const filteredData = useSelector((state) => state.realEstates.filteredData);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const dispatch = useDispatch();
  const filters = useSelector((state) => state.realEstates.filters);
  //const location = useLocation();

  const formik = useFormik({
    initialValues: filters,
    enableReinitialize: true,
    onSubmit: (values) => {
      dispatch(setFilters(values));
    },
  });

  const handleScrollToContent = () => {
    scrollToRealEstatesContent();
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) {
      return;
    }
    setCurrentPage(pageNumber);
    const viewportHeight = window.innerHeight;
    const remInPx = parseFloat(
      getComputedStyle(document.documentElement).fontSize
    );
    const offset = 8 * remInPx;
    const scrollPosition = viewportHeight - offset;
    window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
  };

  const paginatedItems = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleChange = (e) => {
    formik.handleChange(e);
    dispatch(setFilters({ [e.target.name]: e.target.value }));
  };

  const resetFilters = () => {
    formik.resetForm({ values: EMPTY_FILTERS });
    dispatch(clearRealEstatesFilter());
  };

  return (
    <div className="mt-32">
      <RealEstatesHeroSection onScrollToContent={handleScrollToContent} />
      <div id="real-estates-content-section" className="mt-12">
        <div className="flex flex-col items-center justify-center mt-14 pb-12">
          <motion.h2
            id="real-estates-title"
            className="text-2xl sm:text-3xl md:text-4xl tracking-wide font-bold font-heading leading-none text-gray-700 text-center"
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, ease: 'easeOut' }}
          >
            Busca tu mejor opción de inmueble
          </motion.h2>
          <motion.div
            className="h-1 w-36 sm:w-40 mt-4 rounded-full bg-gradient-to-r from-customBlue via-customYellow/50 to-customBlue"
            style={{ backgroundSize: '200% 100%' }}
            animate={{ backgroundPosition: ['0% 0', '100% 0', '0% 0'] }}
            transition={{ duration: 3, repeat: Infinity, ease: 'linear' }}
          />
        </div>
        <div className="w-full min-h-[70vh] px-4 md:px-8">
          {/* Filtros arriba, ocupando todo el ancho */}
          <div className="w-full mb-6">
            <RealEstatesFilters
              formik={formik}
              realEstateTypes={realEstateTypes}
              onChange={handleChange}
              onReset={resetFilters}
            />
          </div>
          {/* Grid abajo, ocupando todo el ancho */}
          <div className="w-full">
            <RealEstatesGrid
              items={paginatedItems}
              realEstateTypes={realEstateTypes}
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
